import { useCallback } from 'react';
import { Palette, useTheme } from '@mui/material';

import { ColorMode } from 'src/components/app/types';

export function getCSATColor(
  palette: Palette,
  score?: number | null,
  colorMode: ColorMode = 'light',
) {
  if (typeof score !== 'number') {
    return palette.colors.grey[500];
  }
  if (score >= 3 && score < 4) {
    return colorMode === 'light' ? palette.colors.black : palette.colors.white;
  }
  if (score >= 4) {
    return palette.colors.green[500];
  }
  return palette.colors.red[500];
}

export default function useGetCSATColor() {
  const { palette } = useTheme();

  return useCallback(
    (score?: number | null, colorMode?: ColorMode) =>
      getCSATColor(palette, score, colorMode),
    [palette],
  );
}
